import { useState } from "react";
import VeyraLogo from "@/components/brand/VeyraLogo";
import PasswordInput from "@/components/common/PasswordInput";
import { useAuth } from "@/store/AuthContext";
import { t } from "@/i18n";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-sm font-medium">{label}</span>
    {children}
  </label>
);

const LoginPage = () => {
  const { login, setupRequired, authLoading } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login({ email: form.email.trim(), password: form.password });
    } catch (err) {
      setError(t.auth[err.message] || t.auth.generic);
    } finally {
      setBusy(false);
    }
  };

  const showSetupLink = !authLoading && setupRequired === true;

  return (
    <div data-testid="login-page" className="flex min-h-screen items-center justify-center bg-[#101010] px-4 text-[#f4f1ec]">
      <div className="w-full max-w-sm v-fade-up">
        <VeyraLogo size={30} className="mb-8" />
        <h1 className="text-2xl font-semibold tracking-tight">{t.auth.loginTitle}</h1>
        <p className="mt-2 text-sm text-[#a3a3a3]">{t.auth.loginSubtitle}</p>
        <form onSubmit={submit} className="mt-8 flex flex-col gap-4">
          <Field label={t.auth.email}>
            <input data-testid="login-email" required type="email" autoFocus className="v-input" placeholder={t.auth.emailPh} value={form.email} onChange={set("email")} />
          </Field>
          <Field label={t.auth.password}>
            <PasswordInput data-testid="login-password" required value={form.password} onChange={set("password")} />
          </Field>
          {error && <p data-testid="login-error" className="text-sm text-[#e5655a]">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={busy} className="v-btn-primary justify-center">{busy ? t.auth.loggingIn : t.auth.loginButton}</button>
        </form>
        <div className="mt-4 text-center">
          <a data-testid="login-forgot-password" href="/recovery" className="text-xs text-[#6b6b6b] underline-offset-2 hover:underline hover:text-[#a3a3a3]">{t.auth.forgotPassword}</a>
        </div>
        {showSetupLink && (
          <a data-testid="login-reclaim-link" href="/setup" className="mt-4 block text-center text-xs text-[#6b6b6b] underline-offset-2 hover:underline">{t.auth.reclaimLink}</a>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
